import React, { createContext, useContext, useState, useCallback } from "react";

const ViewMetadataContext = createContext();

export const useViewMetadata = () => {
  const context = useContext(ViewMetadataContext);
  if (!context) {
    throw new Error(
      "useViewMetadata must be used within a ViewMetadataProvider",
    );
  }
  return context;
};

export const ViewMetadataProvider = ({ children }) => {
  // Store distributions data
  const [globalDistributions, setGlobalDistributions] = useState({});
  const [filteredDistributions, setFilteredDistributions] = useState({});
  const [loadingDistributions, setLoadingDistributions] = useState(true);

  // Find & Replace panel state
  const [findReplacePanel, setFindReplacePanel] = useState({
    isOpen: false,
    column: null,
  });

  // Update distributions
  const updateDistributions = useCallback(
    (global, filtered, loading = false) => {
      setGlobalDistributions(global || {});
      setFilteredDistributions(filtered || {});
      setLoadingDistributions(loading);
    },
    [],
  );

  // Find & Replace panel handlers
  const openFindReplace = useCallback((column) => {
    setFindReplacePanel({
      isOpen: true,
      column: column,
    });
  }, []);

  const closeFindReplace = useCallback(() => {
    setFindReplacePanel({
      isOpen: false,
      column: null,
    });
  }, []);

  // Get distribution for a specific column
  const getColumnDistribution = useCallback(
    (column) => {
      return filteredDistributions[column] || globalDistributions[column] || {};
    },
    [filteredDistributions, globalDistributions],
  );

  const value = {
    // Distributions data
    globalDistributions,
    filteredDistributions,
    loadingDistributions,
    updateDistributions,
    getColumnDistribution,

    // Find & Replace panel
    findReplacePanel,
    openFindReplace,
    closeFindReplace,
  };

  return (
    <ViewMetadataContext.Provider value={value}>
      {children}
    </ViewMetadataContext.Provider>
  );
};

export default ViewMetadataContext;
